import { Modal } from 'view-design'

export default {
  before_close: resolve => {
    Modal.confirm({
      title: '系统提示',
      content: '您正在编辑内容，离开将放弃原来的批量操作，确定要退出吗？',
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  },
  tag_close: resolve => {
    Modal.confirm({
      title: '系统提示',
      content: '您可能正在编辑内容，关闭标签将放弃原来的操作，确定要关闭吗？',
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  }
}
